$(document).ready(function(){

  // Add classes to parents
  $('.menu-items .dropdown .dropdown-menu').parent().addClass('parent');
  $('.menu-items .dropdown .dropdown-menu .tt-megamenu-submenu li ul').parent().addClass('parent');

  // Toggle first level
  $('.menu-items .dropdown').hover(function(){
    $(this).find('.dropdown-menu').toggle();
  });

  // Toggle second level
  $('.menu-items .dropdown .tt-megamenu-submenu li').hover(function(){
    if ($(this).has('ul')) {
      $(this).find('ul').toggleClass('show_menu');
    }
  });

  // Cookie Bar
  var cookie = $.cookie('cookie')

  if(cookie !== 'True'){ 
    $('.cookie_bar').addClass('active'); 
  };

  $('.cookie_bar .ok').click(function(){
    $.cookie('cookie', 'True', { expires: 28, path: '/' })
    $('.cookie_bar').removeClass('active');
  });

  // Size Guide
  $('.table_select .item').click(function(){
    $('.table_select .item').removeClass('active');
    $(this).addClass('active');

    // Open the required Table
    $('#sizeGuide table').removeClass('active');

    if ( $(this).hasClass('one') ){
      $('#one').addClass('active');
    } else if ( $(this).hasClass('two') ){
      $('#two').addClass('active');
    } else if ( $(this).hasClass('three') ){
      $('#three').addClass('active');
    } else if ( $(this).hasClass('four') ){
      $('#four').addClass('active');
    } else if ( $(this).hasClass('five') ){
      $('#five').addClass('active');
    } else if ( $(this).hasClass('six') ){
      $('#six').addClass('active');
    }
    
  });


  // Category Page
  $('#products .products .product .button button').click(function(){
    var text = $(this).parent().parent().find('.content h3').text();

    $('#form select').val(text).change();
    
    $('html, body').animate({
        scrollTop: $("#form").offset().top
    }, 2000);
  });

  // FAQ Block
  $('#faqs .faq h4').click(function(){
    $(this).toggleClass('open');
    $(this).parent().find('p').slideToggle();
  });


  $('#products .products h3').click(function(){
      
  });




  
});